"use client";

import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { latestViewedProductsAtom } from "./productAtoms";
import { RESET } from "jotai/utils";
import {
  deleteResetLastViewedCookie,
  getResetLastViewedCookie,
} from "@/utils/functions/cookieOperations";

export const useCacheInvalidation = () => {
  const setLatestViewed = useSetAtom(latestViewedProductsAtom);

  useEffect(() => {
    const checkAndClearCache = () => {
      const resetCookie = getResetLastViewedCookie();

      if (resetCookie) {
        // Clear the atom
        setLatestViewed(RESET);

        // Remove the cookie
        deleteResetLastViewedCookie();
      }
    };

    checkAndClearCache();
  }, [setLatestViewed]);
};
